import { delay } from 'redux-saga';
import { takeLatest, call } from 'redux-saga/effects';

import {
  invalidateAllAssemblyTreeQueries,
  invalidateAllBOMRestructureQueries,
} from 'modules/quotes/quoteItemComponents/assemblyTree/data/utils';

import { types } from './actions';

export default function* root() {
  yield takeLatest(
    types.ASSEMBLY_TREE_MARK_TREE_NEEDS_UPDATE,
    watchMarkAssemblyTreeNeedsUpdate,
  );
}

function* watchMarkAssemblyTreeNeedsUpdate(action) {
  try {
    invalidateAllBOMRestructureQueries();
    const { payload } = action;
    const { delayTime } = payload;
    if (delayTime) {
      yield call(delay, delayTime);
    }
    invalidateAllAssemblyTreeQueries();
  } catch (error) {
    console.error(
      'There was an error in watchMarkAssemblyTreeNeedsUpdate',
      error,
    );
  }
}
